import React from 'react';

function TermsOfUse() {
  return (
    <section className='section text-center'>
      <h1>Terms Of Use</h1>
      <p>
      Welcome to JSProperty. By accessing and using our website (www.jsproperty.com.sg), you agree to comply with and be bound by the following Terms of Use. If you do not agree with any part of these terms, please do not use our website.</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
      By using this website, you agree to be legally bound by these terms, including our Disclaimers & Copyright Notice and Privacy Policy. We may update or revise these terms from time to time without prior notice. Your continued use of the website constitutes your acceptance of any changes.
      </p>

      <h2>2. Use of Website</h2>

      <p>You agree to use the website only for lawful purposes and in a manner that does not infringe the rights of, restrict or inhibit anyone else's use of the website. Prohibited behavior includes transmitting obscene or offensive content or disrupting the normal flow of dialogue within the website.</p>
      
      <h2>3. Intellectual Property</h2>
      <p>
      All content, design, images, and intellectual property on this website are owned by or licensed to JSProperty, unless otherwise stated. You may not reproduce, copy, distribute, or use for commercial purposes any content without prior written consent.
      </p>

      <h2>4. Property Listings and Information</h2>
      <p>
      All property listings, descriptions, and other content are provided for informational purposes only. JSProperty makes no guarantees regarding the accuracy, completeness, or reliability of this information. Users should conduct their own due diligence before making any property-related decisions.
      </p>

      <h2>5. Third-Party Links</h2>
      <p>
      This website may contain links to third-party websites. JSProperty is not responsible for the content or privacy practices of these external websites. The inclusion of any links does not imply endorsement by JSProperty.
      </p>

      <h2>6. User Accounts (If Applicable)</h2>
      <p>
      If you create an account on our website, you are responsible for maintaining the confidentiality of your login information and for all activities under your account. JSProperty reserves the right to suspend or terminate accounts at its sole discretion.
      </p>
      
      <h2>7. Limitation of Liability</h2>
      <p>
      JSProperty shall not be liable for any damages, including but not limited to direct, indirect, incidental, or consequential damages, arising out of your access to or use of the website.
      </p>
      
      <h2>8. Indemnification</h2>
      <p>
      You agree to indemnify, defend, and hold harmless JSProperty and its affiliates, directors, employees, and agents from and against all claims, liabilities, damages, losses, or expenses arising from your use of the website or violation of these terms.
      </p>

      <h2>9. Governing Law</h2>
      <p>
      These Terms of Use shall be governed by and construed in accordance with the laws of the Republic of Singapore. Any disputes arising shall be subject to the exclusive jurisdiction of the Singapore courts.
      </p>
    </section>
  );
}

export default TermsOfUse;